import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export interface StyledTextFieldClasses {
	/** styles applied to the root element */
	root: string;
	loading: string;
	textarea: string;
	inherit: string;
}

export function getStyledTextFieldUtilityClass(slot: string) {
	return generateUtilityClass('StyledTextField', slot);
}

const styledTextFieldClasses = generateUtilityClasses<
	keyof StyledTextFieldClasses
>('StyledTextField', ['root', 'inherit', 'loading', 'textarea']);
export default styledTextFieldClasses;
